__turbopack_context__.v({
  "cta": "_5Gcy3W_cta",
  "illustration": "_5Gcy3W_illustration",
  "title": "_5Gcy3W_title",
  "wrapper": "_5Gcy3W_wrapper",
});
